import { Controller } from "@hotwired/stimulus"

// Opens a centered <dialog> modal for creating a new ticket with full fields.
// Closes on ESC, backdrop click, or explicit close button. Prompts before
// discarding if the form has been edited.
export default class extends Controller {
  static targets = ["dialog", "form"]

  connect() {
    this._initialFormState = null
  }

  open() {
    if (this.hasDialogTarget && !this.dialogTarget.open) {
      this._initialFormState = this._getFormState()
      this.dialogTarget.showModal()
      // Focus the title field
      const titleInput = this.dialogTarget.querySelector('input[name="story[title]"]')
      if (titleInput) titleInput.focus()
    }
  }

  close(event) {
    if (!this.hasDialogTarget || !this.dialogTarget.open) return

    // If triggered by form submission, allow it
    if (event?.detail?.submitting) {
      this.dialogTarget.close()
      return
    }

    // Check if form is dirty
    if (this._isFormDirty()) {
      if (!confirm("Discard the ticket you were creating?")) {
        event?.preventDefault()
        return
      }
    }

    this.dialogTarget.close()
    this._resetForm()
  }

  // Close when the click lands on the backdrop (the dialog element itself)
  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  // Handle ESC key
  handleEscape(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    }
  }

  _isFormDirty() {
    if (!this.hasFormTarget || !this._initialFormState) return false
    const currentState = this._getFormState()
    return currentState !== this._initialFormState
  }

  _getFormState() {
    if (!this.hasFormTarget) return ""
    const formData = new FormData(this.formTarget)
    const values = []
    for (const [key, value] of formData.entries()) {
      if (value) values.push(`${key}=${value}`)
    }
    return values.join("&")
  }

  _resetForm() {
    if (this.hasFormTarget) {
      this.formTarget.reset()
      this._initialFormState = null
    }
  }
}
